import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	UpdateBatchProcedure,
	UpdateBatchProcedureParams,
	UpdateBatchProcedureResponse,
} from 'domain/usecases/private/refund/request/update-batch-procedure';

export class RemoteRefundUpdateBatchProcedure implements UpdateBatchProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<UpdateBatchProcedureResponse>,
	) {}

	async update(params: UpdateBatchProcedureParams): Promise<UpdateBatchProcedureResponse> {
		const {protocolDetail, ...body} = params;
		const url = this.url
			.replace(':protocolCode', protocolDetail.protocolCode)
			.replace(':requestCode', protocolDetail.requestCode);

		const httpResponse = await this.httpClient.request({
			url,
			method: 'patch',
			body,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
